<template>
    <v-container fluid fill-height>
        <v-card  outlined width="100%" class="fill-height">
            <v-card-text class="pa-5">
                <v-row>
                    <v-col cols=6 md=6 lg=6 sm=6>
                        <v-chip label color="amber"> <v-icon left>mdi-account-multiple</v-icon>Party Manager</v-chip>
                    </v-col>
                    <v-col cols=6 md=6 lg=6 sm=6 style="postion:relative">
                        <v-speed-dial v-model="fab" direction="left" :open-on-hover="false" 
                        transition="slide-y-reverse-transition" class="Speed-button-Setting">
                            <template v-slot:activator>
                                <v-btn v-model="fab" color="amber" fab class="elevation-0">
                                <v-icon v-if="fab">mdi-close</v-icon>
                                <v-icon v-else>mdi-account-multiple</v-icon>
                                </v-btn>
                            </template>
                            <v-btn fab dark small color="indigo" @click="CreateBox = true"><v-icon>mdi-plus</v-icon></v-btn>
                            <v-btn fab dark small color="red" v-if="selection.length > 0" @click="delconfirmbox = true"><v-icon>mdi-delete</v-icon></v-btn>
                        </v-speed-dial>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12 md=12 lg=12 sm=12>
                        <v-card flat>
                            <v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" outlined
                                color="amber" append-icon="mdi-magnify" dense
                                 label="Search" hide-details></v-text-field>
                            </v-card-title>
                            <v-data-table :headers="headers" v-model="selection" :items="records" :search="search" :show-select="role =='admin' ? true : false">
                                <template v-slot:item.action="{ item }">
                                    <v-btn color="amber" fab small class="elevation-0" @click="EditBox = true; partyId=item.id"><v-icon color="black">mdi-pencil</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row> 
            </v-card-text>           
        </v-card>
        <v-dialog v-model="delconfirmbox" persistent max-width="350">
            <v-card class="text-center">
                <v-card-title class="subheading" v-if="askcontent"><p class="mb-0 text-xs-center" style="width:100%;">Are you Sure ?</p></v-card-title>
                <v-card-title class="subheading" v-if="actionData === true"><p class="mb-0 text-xs-center" style="width:100%;">{{response.message}}!</p></v-card-title>
                <v-card-title class="subheading" v-if="actionData === false"><p class="mb-0 text-xs-center" style="width:100%;">{{response.message}}!</p></v-card-title>
                <v-card-title class="headline" v-if="loading"><p class="mb-0 text-xs-center" style="width:100%;">Hit to Server ...</p></v-card-title>
                <v-card-text v-if="actionData === false">{{response.error}}</v-card-text>
                <v-card-text v-if="actionData === true" class="text-xs-center">
                    <v-scroll-x-transition>
                        <v-icon color="#3268ae" size="80px"> mdi-checkbox-marked-circle-outline</v-icon>
                    </v-scroll-x-transition>
                </v-card-text>
                <v-card-text v-if="loading" class="text-xs-center"><v-progress-circular :size="70" color="#3268ae" indeterminate></v-progress-circular> </v-card-text>
                <v-card-text v-if="askcontent">Selected Parties <b>({{selection.length}})</b></v-card-text>
                <v-card-actions v-if="askcontent">
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="delconfirmbox = false">No</v-btn>
                <v-btn color="green darken-1" text @click="deleteselected">Yes</v-btn>
                </v-card-actions>
                <v-card-actions v-if="actionData === true" class="text-xs-center">
                <v-btn color="#3268ae" text block @click="ActionOkay" dark>Okay</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="CreateBox" persistent="" transition="dialog-bottom-transition" max-width="800">
            <Party :edit="false" @Response="action($event)" @Close="CreateBox = false"></Party>
        </v-dialog>
        <v-dialog v-model="EditBox" persistent="" transition="dialog-bottom-transition" max-width="800">
            <Party :edit="true" :id='partyId' @Response="action($event)" @Close="EditBox = false"></Party>
        </v-dialog>
        <v-snackbar v-model="notificationBar" top center :color="notificationColor" multi-line> {{ notificationText }}
            <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
import Party from '../../components/party/index'
import { SERVER_API } from '../../API';
import {store} from '../../store'
export default {
    components:{Party},
    mounted(){
        this.fetchall();
    },
    data(){
        return{
             role:store.state.role,
            partyId:'',
            EditBox:false,
            CreateBox:false,
            search:'',
            fab:false,
            headers:[
                { text: 'Person ', value: 'personName' },
                { text: 'Company', value: 'companyName' },
                { text: 'Phone', value: 'phone' },
                 { text: 'Address', value: 'address' },
                { text: 'GST', value: 'gst' },
                { text: 'City', value: 'city' },
                { text: 'Action', value: 'action' },
            ],
            records:[],
            selection:[],
            // Confirmation
            delconfirmbox:false,
            loading:false,
            actionData:'',
            askcontent:true,
            response:{
                message:'',
                error:''
            },

            // Notification Setting
            notificationColor: 'black',
            notificationBar: false,
            notificationText:''
        }
    },
    computed:{
        deleteconveter(){
            var deleteId = [...new Set(this.selection.map(it => it.id))];
                return deleteId;
        }
    },
    methods:{
        async deleteselected(){
            this.loading = true;
            this.askcontent = false;
            try{
                let del_ids = this.deleteconveter.toString();
                const response = await this.$http.delete(SERVER_API+'/party/delete/'+del_ids);
                if(response.data.action === true){
                this.response.message = response.data.message;
                this.loading = false;
                this.actionData = response.data.action;
                }
            }catch(e){
                this.response.message = e;
                this.loading = false;
                this.actionData = false;
            }
        },
        async fetchall(){
            const response =  await this.$http.get(SERVER_API+'/party/records');
            this.records = response.data.data;
        },
        async ActionOkay(){
            this.fetchall();
            this.askcontent = true;
            this.actionData = "";
            this.delconfirmbox = false;
            this.selection = [];
        },
        action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                this.fetchall();
                this.CreateBox = false;
                this.EditBox = false;
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = e.message;
                //console.log(e);
            }
        }
    }

}
</script>

<style>
.Speed-button-Setting{
    position:absolute;
    right:30px;
}
</style>